import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { EnvironmentTitle, HeroPanel } from 'view/shared/heroPanel'
import { WindowActions } from 'epics/windowEpic'
import { Locale, Translation } from 'locale'

type SalesCoverageHeroPanelProps = DispatchProps

interface OwnProps {}

interface StateProps {}

interface DispatchProps {
  onTearout: () => void
}

const mapStateToProps = createStructuredSelector({})

const mapDispatchToProps = {
  onTearout: () => WindowActions.tearoutGrid('/quote/tearout/salesCoverage')
}

const SalesCoverageHeroPanelComponent: React.FunctionComponent<SalesCoverageHeroPanelProps> = props => {
  return (
    <HeroPanel onTearout={props.onTearout}>
      <EnvironmentTitle data-test-id={'SalesCoverageHeroPanel-EnvironmentTitle'}>
        {Locale.translate(Translation.TC_HERO_SALES_COVERAGE)}
      </EnvironmentTitle>
    </HeroPanel>
  )
}

export const SalesCoverageHeroPanel = connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(SalesCoverageHeroPanelComponent)
